// Batch size for bulk uploads (Rotation, Unique Allocation, etc.)
export const UPLOAD_BATCH_SIZE = 500;

// Maintenance window config (IST 24h format)
// Update these values to change the maintenance start/end times.
export const MAINTENANCE_START_HOUR_IST = 17; // hour in 24h format (IST)
export const MAINTENANCE_START_MINUTE_IST = 0; // minutes
export const MAINTENANCE_END_HOUR_IST = 18;   // hour in 24h format (IST)
export const MAINTENANCE_END_MINUTE_IST = 0; // minutes

// Default pagination settings for all tables across the application
export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 500];
// For MUI DataGrid tables (pageSize + rowsPerPageOptions)
export const DEFAULT_PAGE_SIZE_OPTIONS_MUI = [25, 50, 100, 500];

export default {
  UPLOAD_BATCH_SIZE,
  MAINTENANCE_START_HOUR_IST,
  MAINTENANCE_START_MINUTE_IST,
  MAINTENANCE_END_HOUR_IST,
  MAINTENANCE_END_MINUTE_IST,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_OPTIONS,
  DEFAULT_PAGE_SIZE_OPTIONS_MUI,
};